import { useState } from "react";
import { useNavigate } from "react-router";

import { TaskCreateSheet } from "../../tasks/TaskCreateSheet";
import type { AttentionItem } from "./homeModel";

/**
 * «Próximo paso» of a deal. With contacts, the regular task sheet opens on
 * the deal's first contact (that is how a task counts as the deal's next
 * step). Without contacts, the team-task form opens linked to the deal.
 * `children` receives the handler to wire on each row.
 */
export const NextStepProvider = ({
  children,
}: {
  children: (onNextStep: (item: AttentionItem) => void) => React.ReactNode;
}) => {
  const navigate = useNavigate();
  const [contactId, setContactId] = useState<AttentionItem["contactId"]>(null);

  const onNextStep = (item: AttentionItem) => {
    const contact = item.contactIds?.[0];
    if (contact != null) {
      setContactId(contact);
      return;
    }
    const source = encodeURIComponent(JSON.stringify({ deal_id: item.id }));
    navigate(`/team_tasks/create?source=${source}`);
  };

  return (
    <>
      {children(onNextStep)}
      {contactId != null ? (
        <TaskCreateSheet
          open
          contact_id={contactId}
          onOpenChange={(open) => {
            if (!open) setContactId(null);
          }}
        />
      ) : null}
    </>
  );
};
